export function humanizeFieldName (fieldName) {
  return fieldName.replace(/[^a-zA-Z]+/g, ' ').trim()
}
